app.controller(
    'ConsultationFlaneriesController', ['$scope', '$rootScope', '$document', '$sce', '$http', '$stateParams', '$state', 'FlaneriesService', '$translate', 'SideBarService', 'HelperService', 'ShareUrlService', 'ExplorerService', '$window',  ConsulationFlaneriesController]
);


function ConsulationFlaneriesController($scope, $rootScope, $document, $sce, $http, $stateParams, $state, FlaneriesService, $translate, SideBarService, HelperService, ShareUrlService, ExplorerService,$window) {
    var vm = this;

    $scope.contentTranslate = null;

    vm.ActiveDescription = {};
    vm.ActiveDescriptionId = 0;
    vm.IsCreatingNewDescriptionForIti = false;
    vm.Iti = {
        DescriptionPositionList: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]
    };

    vm.ActiveDescriptionVm =
        {
            Clients: [{ "name": "" }, { "name": "" }, { "name": "" }, { "name": "" }, { "name": "" }],
            QualificationList: [{ "name": "" }, { "name": "" }, { "name": "" }, { "name": "" }, { "name": "" }],
            DescriptionNewPositionText: '1'
        };



    $scope.addStep = function () {
        var ItiGetEmpty = FlaneriesService.GetEmptyStep(vm.Iti.Iti.ItineraryId, $scope.CurrentLang);
        ItiGetEmpty.then(function (t) {
            var res = t.data;
            vm.Iti.newstep = res;
            vm.Iti.ItineraryStepList.push(vm.Iti.newstep);
        },
        function (e) {
            console.log('Chargement du lieu impossible', e);
        });
    };
    $scope.removeStep = function (step, itistepid) {
        vm.Iti.ItineraryStepList.splice(step, 1);
        FlaneriesService.RemoveStep(vm.Iti, itistepid, $scope.CurrentLang, function (response) {
        });
    };
    //strat
    if ($stateParams.lang) {
        $scope.CurrentLang = $stateParams.lang;
    }
    else {
        $scope.CurrentLang = 'fr';
    }    
    if ($stateParams.z) {
        vm.ParamZoneId = $stateParams.z;
    }
    else {
        vm.ParamZoneId = $rootScope.DefaultGlobalZoneId;
    }
    $rootScope.CurrentZoneId = vm.ParamZoneId;

    $translate.use($rootScope.LangForInterface);
    
    //Associated places on sidebar
    if ($state.current.name == "app.consultation.flaneries" || $state.current.name == "app.consultation.walk") {        
        $rootScope.AllowChangeAssociatedPlacePosition = true;
    }
    else {
        $rootScope.AllowChangeAssociatedPlacePosition = false;
    }

    //load place
    //$scope.vm = {};
    $scope.edit = {};
    FlaneriesService.getFlaneries($stateParams.id, $stateParams.lang, "", $stateParams.index, $stateParams.sortKey, $stateParams.reverse, $stateParams.filter, $stateParams.countryId, $stateParams.CityId, $stateParams.UpdateDate, $stateParams.CreationDate, $stateParams.statusId, $stateParams.clid, $stateParams.langCode, $stateParams.Duration)
     .then(function (t) {
         var res = t.data;
         //  $scope.vm = res;

         $rootScope.vm.Iti = res;

         vm.Iti = res;
         if (vm.Iti.DescriptionList.length > 0) {
             if ($stateParams.descpos) {
                 if ($stateParams.descpos > vm.Iti.DescriptionList.length) {
                     $stateParams.descpos = vm.Iti.DescriptionList.length;
                 }
                 vm.ActiveDescriptionId = $stateParams.descpos - 1;
             }
             else {
                 vm.ActiveDescriptionId = 0;
             }
             vm.ActiveDescription = vm.Iti.DescriptionList[vm.ActiveDescriptionId].Description;
             vm.GetDescriptionVm();
         }
         $rootScope.SideBar = res.SideBar;
         $rootScope.Clients = res.ClientList;
         $rootScope.ClassificationList = res.ClassificationList
         // $rootScope.PlaceList = res.PlaceList;
         $rootScope.CurrentObjectId = $stateParams.id;
         $rootScope.CurrentPageType = $rootScope.EnumLinkType.Itinerary;
         $rootScope.CurrentObjectStatus = res.CurrentItineraryStatus;
         $rootScope.SideBar.CurrentObjectStatus = $rootScope.CurrentObjectStatus
         $rootScope.SideBar.StatusList = $rootScope.StatusList4WorkflowObjectSt;
         $rootScope.SideBar.MesNotes = vm.Iti.Iti.MyNotes;

         //  $scope.placeSteps = res.PlaceStepList;
         vm.GetAssociatedZonesOnSideBar();
         vm.GetPlaceByCityForSteps();
         vm.GetAssociatedFilesOnSideBar();

         $scope.GetAssociatedPlacesOnSideBar();
         //$scope.ChangeZoneById(vm.ParamZoneId);

         //Parent QC and length limit for description       
         $rootScope.CheckDescriptionLengthLimitForObject(res.ParentQcId);

         vm.StatusList4WorkflowDescriptionObj = angular.copy($rootScope.StatusList4WorkflowDescriptionSt);
     },
   function (e) {
       console.log('Chargement du lieu impossible', e);
   });


    vm.UpdateDescriptionVm = function () {
        if (!vm.IsCreatingNewDescriptionForIti) {
            HelperService.UpdateDescriptionVm(vm.ActiveDescriptionVm, $rootScope.EnumLinkType.Itinerary)
            .then(
               function success(data) {
                   //recharge la page si la position du desc est modifié
                   if (vm.ActiveDescriptionVm.DescriptionCurrentPositionText != vm.ActiveDescriptionVm.DescriptionNewPositionText) {
                       window.location.reload();
                   }
               },
               function error(data) { });
        }
        else {
            vm.CreateNewDescriptionForIti();
        }
    }

    vm.GetDescriptionVm = function () {
        HelperService.GetDescriptionVmWithSort(vm.Iti.DescriptionList[vm.ActiveDescriptionId].Description.DescriptionId, vm.Iti.Iti.ItineraryId, $rootScope.EnumLinkType.Itinerary, 0, $scope.CurrentLang)
            .then(function (desc) {
                vm.ActiveDescriptionVm = desc;
            });
    }
    vm.PrepareCreateNewDescriptionForIti = function () {
        //add new desc local
        vm.IsCreatingNewDescriptionForIti = true;
        var newDescLocal = {};
        newDescLocal.DescriptionId = 0;

        vm.ActiveDescriptionVm.Description = {};
        vm.ActiveDescriptionVm.Description.DescriptionId = 0;
        vm.ActiveDescriptionVm.Description.DescriptionTitle = '';
        vm.ActiveDescriptionVm.Description.Stick = '';
        vm.ActiveDescriptionVm.Description.Resume = '';
        vm.ActiveDescriptionVm.Description.Description = '';
        vm.ActiveDescriptionVm.DescriptionStatus = '';
        vm.ActiveDescriptionVm.Clients = [];
        vm.ActiveDescriptionVm.QualificationList = [];
        var lastIndex = vm.Iti.DescriptionList.push(newDescLocal) - 1;
        vm.ActiveDescriptionId = lastIndex;
    }


    vm.CreateNewDescriptionForIti = function () {
        //prepare data supplement
        var descForCreation = {};
        descForCreation.ObjectId = vm.Iti.Iti.ItineraryId;
        descForCreation.CurrentLang = $scope.CurrentLang;
        descForCreation.LinkTypeId = $rootScope.EnumLinkType.Itinerary;
        descForCreation.DescriptionTranslation = vm.ActiveDescriptionVm.Description;
        descForCreation.DescriptionStatus = vm.ActiveDescriptionVm.DescriptionStatus;

        FlaneriesService.CreateNewDescriptionForIti(descForCreation)
        .then(
                function success(data) {
                    vm.IsCreatingNewDescriptionForIti = false;
                    vm.Iti.DescriptionList[vm.ActiveDescriptionId].Description = $rootScope.returnNewDesc;
                    $state.go('app.consultation.flaneries', { id: vm.Iti.Iti.ItineraryId, lang: $scope.CurrentLang, index: $stateParams.index, sortKey: $stateParams.sortKey, reverse: $stateParams.reverse, z: $stateParams.z, descpos: vm.Iti.DescriptionList.length });
                },
                function error(data) { });
    }

    vm.OpenInOtherLang = function (lang) {
        $window.location.href = $rootScope.interfaceSubFolder + '/#!/consultation/flaneries?id=' + vm.Iti.Iti.ItineraryId + "&lang=" + lang + "&index=" + $stateParams.index + "&sortKey=" + $stateParams.sortKey + "&reverse=" + $stateParams.reverse + "&z=" + $stateParams.z;
    }

    vm.PreviousDesc = function () {
        if (vm.Iti.DescriptionList.length > 0 && vm.ActiveDescriptionId > 0) {
            vm.ActiveDescriptionId = vm.ActiveDescriptionId - 1;
            $state.transitionTo('app.consultation.flaneries', { id: vm.Iti.Iti.ItineraryId, lang: $scope.CurrentLang, index: $stateParams.index, sortKey: $stateParams.sortKey, reverse: $stateParams.reverse, z: $stateParams.z, descpos: vm.ActiveDescriptionId + 1 }, { notify: false });
            vm.GetDescriptionVm();
        }
    }

    vm.NextDesc = function () {
        if (vm.Iti.DescriptionList.length > 0 && vm.ActiveDescriptionId < vm.Iti.DescriptionList.length - 1) {
            vm.ActiveDescriptionId = vm.ActiveDescriptionId + 1;
            $state.transitionTo('app.consultation.flaneries', { id: vm.Iti.Iti.ItineraryId, lang: $scope.CurrentLang, index: $stateParams.index, sortKey: $stateParams.sortKey, reverse: $stateParams.reverse, z: $stateParams.z, descpos: vm.ActiveDescriptionId + 1 }, { notify: false });
            vm.GetDescriptionVm();
        }
    }


    vm.UpdateDescriptionPosition = function () {
        if (vm.ActiveDescriptionVm.Description != undefined && vm.ActiveDescriptionVm.Description.DescriptionId != 0) {
            HelperService.UpdateDescriptionPosition(vm.Iti.Iti.ItineraryId, vm.ActiveDescriptionVm.Description.DescriptionId, vm.ActiveDescriptionVm.DescriptionCurrentPositionText, vm.ActiveDescriptionVm.DescriptionNewPositionText, $rootScope.EnumLinkType.Itinerary);
        }
    }




    $scope.GetAssociatedPlacesOnSideBar = function () {
        HelperService.GetAssociatedPlacesOnSideBar($stateParams.id, 15, $scope.CurrentLang, true)
            .then(function (data) {
                $rootScope.AssociatedPlaces = data;
                //$rootScope.AssociatedPlaces = angular.copy(data);
                //$rootScope.AssociatedPlacesWithPosition = angular.copy(data);
                $rootScope.AllowChangeAssociatedPlacePosition = true;
            });
    }
    $rootScope.SaveAssociatedPlaces = function SaveAssociatedPlaces(withPosition) {
        promiseAddComment = SideBarService.SaveAssociatedPlaces($stateParams.id, 15, $scope.CurrentLang, $rootScope.AssociatedPlaces)
        .then(
            function success(data) {
                    $rootScope.ReloadThisPage();
                },
                function error(data) { });
    };

    vm.GetPlaceByCityForSteps = function () {
        HelperService.GetPlaceByCityForSteps($stateParams.id, 12, $scope.CurrentLang, true)
            .then(function (data) {
                $rootScope.placeSteps = data.singlelist;
                $rootScope.PlaceList = data.placem;
                $rootScope.vm.PlaceList = data.placem;
            });
    }

    vm.GetAssociatedZonesOnSideBar = function () {
        HelperService.GetAssociatedZonesOnSideBar($stateParams.id, $rootScope.EnumLinkType.Itinerary, $scope.CurrentLang)
            .then(function (data) {
                $rootScope.AssociatedZones = data;
            });
    }

    $rootScope.SaveAssociatedZones = function SaveAssociatedZones() {
        promiseAddComment = SideBarService.SaveAssociatedZones($stateParams.id, $rootScope.EnumLinkType.Itinerary, $scope.CurrentLang, $rootScope.AssociatedZones);
    };

    vm.GetAssociatedFilesOnSideBar = function () {
        HelperService.GetAssociatedFilesOnSideBar($stateParams.id, $rootScope.EnumLinkType.Itinerary, $scope.CurrentLang)
            .then(function (data) {
                $rootScope.AssociatedFiles = data;
            });
    }

    $rootScope.DownloadAssociatedFile = function (name, $event) {
        $event.stopPropagation();
        var path = name;
        //path = 'test';
        //if ($stateParams.path !== undefined)
        //    path = $stateParams.path + "/" + name;
        ExplorerService.DownloadAssociatedFile(path, "application/pdf")
            .then(function (response) {
                $scope.selectedItem = null;
            }, function (response) {
                if (response.status > 0) {
                    $scope.errorMsg = response.status + ': ' + response.data;
                }
            }, function (evt) {
                console.log(evt);
                $scope.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total)) + "%";
                console.log($scope.progress);
            }
            );

    };

    $scope.getHtml = function (htmlContent) {
        return $sce.trustAsHtml(htmlContent);
    };

    $scope.UpdateItineraryTranslation = function UpdateItineraryTranslation() {
        FlaneriesService.UpdateItineraryTranslation(vm.Iti, function (response) {
        });
    };

    $scope.UpdateItineraryStepTranslation = function UpdateItineraryStepTranslation(vm, index) {
        
        // [Lam Hong 25-Feb-2022] LVCG-63: LVCG-65 [BO INTERFACE] [24H CREATION] 
        // Get the place ID from the "departure" field(the one the user has input) send it to the both insertions: set ArrivalPlace = DeparturePlace if ArrivalPlace IS NULL
        if (vm.newstep != null && vm.newstep.DepartSelected != null) {
            if (vm.newstep.ArriveeSelected == null) {
                vm.newstep.ArriveeSelected = vm.newstep.DepartSelected;
            }
        }
        else {
            // [Lam Hong 07-Dec-2022] LVCG-63: LVCG-65 [BO INTERFACE] [24H CREATION] => update case
            // console.log(vm);
            if (vm.ItineraryStepList != null && vm.ItineraryStepList.length != null) {
                if (index < vm.ItineraryStepList.length) {
                    console.log(vm.ItineraryStepList[index]);
                    vm.ItineraryStepList[index].ArriveeSelected = vm.ItineraryStepList[index].DepartSelected;
                }
            }
        }
        // END
        FlaneriesService.UpdateItineraryStepTranslation(vm, index, function (response) {
            alert("LVCG-65: UpdateItineraryStepTranslation");
        });
    };



    $scope.UpdateDescription = function UpdateDescription(index) {

        FlaneriesService.UpdateDescriptionIti(index, vm.Iti)
                .then(
                function success(data) {
                    vm.Iti.ItineraryStepList[index].DescriptionList[0].Description.DescriptionId = data.data;
                },
                function error(data) { });

    };





    $scope.UpdateDescriptionStatus = function UpdateDescriptionStatus(status, index) {

        if (index == 0)
            vm.Iti.CurrentDescription.Description.StatusId = status;
        else
            vm.Iti.DescriptionList[index].Description.StatusId = status;
        FlaneriesService.UpdateDescriptionStatusIti(vm.Iti, vm.Iti.CurrentDescription.Description.LanguageCode, status, function (response) {

        });
    };
    

    // SideBar method
    $rootScope.UpdateObjectStatus = function UpdateObjectStatus(status, objectId) {        
        SideBarService.UpdateObjectStatus(status, objectId, $stateParams.lang, $rootScope.EnumLinkType.Itinerary);
    };
    $rootScope.AddComment = function AddComment(CurrentObjectId) {

        promiseAddComment = SideBarService.AddComment($rootScope.vm.SideBar.CommentEdit, $stateParams.id, $rootScope.CurrentLang, 15);

        promiseAddComment
            .then(
                function success(data) {
                    $rootScope.Comments = $rootScope.returnNewComments;
                    $rootScope.SideBar.CommentEdit.Comment = '';
                },
                function error(data) {
                }
            );
    };

    $rootScope.SaveDiffuseur = function SaveDiffuseur() {        
        promiseAddComment = SideBarService.SaveDiffuseur($rootScope.Clients, $stateParams.id, $scope.CurrentLang, 15);
    };

    $rootScope.SaveAdressesAssociees = function SaveAdressesAssociees() {

        promiseAddComment = SideBarService.SaveAdressesAssociees($rootScope.PlaceList, $stateParams.id, $scope.CurrentLang, 15);
    };

    $rootScope.SaveClassification = function SaveClassification() {

        promiseAddComment = SideBarService.SaveClassification($rootScope.vm.ClassificationList, $stateParams.id, $scope.CurrentLang, 15);
    };

    $rootScope.SaveIti = function SaveIti() {

        promiseAddComment = SideBarService.SaveIti($rootScope.vm.Iti, $stateParams.id, $scope.CurrentLang, 15);
    };

    $rootScope.refreshHistory = function refreshHistory() {
        var lastelement = $rootScope.SideBar.HistoryList == null ? null : $rootScope.SideBar.HistoryList.shift();
        promiseRefreshHistory = SideBarService.RefreshHistory($rootScope.CurrentObjectId, $stateParams.lang, "Iti", (lastelement == null ? 0 : lastelement.ChangeLogId));
        promiseRefreshHistory
            .then(
                  function success(data) {
                      $rootScope.SideBar.HistoryList = $rootScope.returnNewHistory.concat($rootScope.SideBar.HistoryList);

                  },
                function error(data) {
                });
    };

    $rootScope.shareInfoPratique = function () {
        $rootScope.shareFicheComplete();
    }

    $rootScope.shareFicheComplete = function () {
        ShareUrlService.GenerateSharedUrl($stateParams.id, $rootScope.EnumLinkType.Itinerary, $rootScope.LangForWork)
            .then(function (data) {
                $rootScope.ShareUrlObj = data.data;
            },
            function (data) {
            }
        );
    }

    //Drag and Drop - Start
    $rootScope.AssociatedPlaceSortableOptions = {
        update: function (e, ui) {
            //console.log($rootScope.AssociatedPlaces);
            var oldIndex = ui.item.sortable.index;
            var newIndex = ui.item.sortable.dropindex;
            if (oldIndex != newIndex) {
                //HelperService.UpdatePlacePositionInItinerary($rootScope.AssociatedPlaces[oldIndex].PlaceId, $stateParams.id, oldIndex + 1, newIndex + 1).
                //then(
                //    function success(data) {
                //        console.log("Done");
                //        //window.location.reload();
                //        //vm.getData(vm.ParamZoneId, vm.pageno, vm.sortKey, vm.reverse, $rootScope.TopBarAction.isActive, $rootScope.TopBarAction.SearchText, $rootScope.SideBarSearchVM);
                //    },
                //    function error(data) { });
            }
        },
        handle: '> .dragHandle',
        'ui-floating': false,
        placeholder: "trholder",
        containment: "parent",
        opacity: 0.3,
        helper: fixHelper,        
        tolerance: "pointer"
    };
    //Drag and Drop - End

    $rootScope.ReloadThisPage = function () {        
        $window.location.reload();
    }
}